import { render, staticRenderFns } from "./blob_overflow_menu.vue?vue&type=template&id=6fbce5be&vue3"
import script from "./blob_overflow_menu.vue?vue&type=script&lang=js&vue3"
export * from "./blob_overflow_menu.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports